import * as React from "react"
import {Drawer} from "@mui/material";

import {SimpleScrollbar} from "..";
import {dsColorNew} from "@palette";

// `footer` renders after the scroll area, so it stays pinned to the foot of the drawer while
// the menu itself scrolls (the drawer's Paper is a flex column)
export default function BaseDesktopDrawer({ children, footer=null, scrollbarProps={} , ...props }) {
    return <Drawer
        open
        variant="permanent"
        {...props}
        PaperProps={{
            ...props?.PaperProps,
            sx: {
                backgroundColor: dsColorNew.navy,
                borderRight: 'none',
                ...props?.PaperProps?.sx
            }
        }}
    >
        <SimpleScrollbar {...scrollbarProps}>
            {children}
        </SimpleScrollbar>
        {footer}
    </Drawer>
}